export const ExperienceSkills = ({ skills, url }: { skills: string[]; url: string }) => (
  <div className="flex flex-wrap gap-2 pt-2">
    {skills.map((skill, idx) => (
      <a
        key={idx}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="px-3 py-1.5 bg-secondary/50 text-secondary-foreground rounded-full text-sm font-medium
                   hover:bg-gradient-to-r hover:from-primary hover:to-accent hover:text-white
                   transition-all duration-300 hover:scale-105 cursor-pointer"
      >
        {skill}
      </a>
    ))}
  </div>
);
